<template>
  <div class="text-center popover-container">
    <h5>{{ plan.name }}</h5>
    <span class="text-success">{{ plan.package_type.name }}</span>
    <p>{{ plan.description }}</p>
    <ul class="features-list" v-if="type === 1">
      <li>
        <span class="text-success">{{ plan.ring_Group }}</span>
        Ring Groups
      </li>
      <li>
        <span class="text-success">{{ plan.ivr }}</span> IVRs
      </li>
      <li>
        <span class="text-success">{{ plan.ext }}</span>
        Extensions
      </li>
      <li>
        <i class="fa fa-check text-success" v-if="plan.queue"></i>
        <i class="fa fa-times text-danger" v-else></i>
        Queue
      </li>
      <li>
        <i class="fa fa-check text-success" v-if="plan.conference"></i>
        <i class="fa fa-times text-danger" v-else></i>
        Conference
      </li>
      <li>
        <i class="fa fa-check text-success" v-if="plan.statistics"></i>
        <i class="fa fa-times text-danger" v-else></i>
        Statistics
      </li>
      <li>
        <i class="fa fa-check text-success" v-if="plan.outbound_calls"></i>
        <i class="fa fa-times text-danger" v-else></i>
        Outbound Calls
      </li>
      <li>
        <i class="fa fa-check text-success" v-if="plan.pbxPortal"></i>
        <i class="fa fa-times text-danger" v-else></i>
        PbxPortal
      </li>
    </ul>
    <ul class="features-list" v-if="type === 2">
      <li>
        <span class="text-success">{{ plan.concurrent_calls }}</span>
        Concurrent Calls
      </li>
      <li v-if="!plan.unlimited_incoming_minutes">
        <span class="text-success">{{ plan.free_incoming_minutes }}</span>
        Incoming Minutes
      </li>
      <li v-if="plan.unlimited_incoming_minutes">
        <i
          class="fa fa-check text-success"
          v-if="plan.unlimited_incoming_minutes"
        ></i>
        <i class="fa fa-times text-danger" v-else></i>
        Unlimited Incoming Minutes
      </li>
      <li v-if="!plan.unlimited_out_pound_minutes">
        <span class="text-success">
          {{ plan.free_out_pound_minutes }}
        </span>
        Outbound Minutes
      </li>
      <li v-if="plan.unlimited_out_pound_minutes">
        <i
          class="fa fa-check text-success"
          v-if="plan.unlimited_out_pound_minutes"
        ></i>
        <i class="fa fa-times text-danger" v-else></i>
        Unlimited Outbound Minutes
      </li>
      <li>
        <span class="text-success">{{ plan.incoming_minutes_rate }}</span>
        Incoming Minutes Rate
      </li>
      <li>{{ plan.city_id }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'PackagePopover',
  props: ['plan', 'type']
}
</script>
